export const article = [
  {
    articleId: 23,
    url: "solucionar-problemas-de-red",
    category: {
      slug:"cuenta",
      name: "Mi cuenta"
    },
    title: "Solucionar problemas de red",
    content: 
      <>
        <h2>Reinicia la red doméstica</h2>
        <p>Al realizar este paso, mantén apagados y desconectados al mismo tiempo el dispositivo y todos los equipos de la red doméstica durante aproximadamente 30 segundos antes de volver a conectarlos uno por uno. </p>
        <div className="rowLine">
          <div className="accordeonContent">
            <ul className="decimal">
              <li>Apaga el dispositivo móvil. </li>
              <li>Desconecta el módem (y el enrutador inalámbrico, si se trata de un dispositivo independiente) de la alimentación eléctrica durante al menos 30 segundos. </li>
              <li>Conecta el módem y espera hasta que todas las luces indicadoras estén encendidas y hayan dejado de parpadear. Si el enrutador es independiente del módem, conéctalo y espera hasta que todas las luces indicadoras hayan dejado de parpadear. </li>
              <li>Vuelve a encender el dispositivo y prueba Mega GO nuevamente. </li>
            </ul>
          </div>
        </div>
        <h2>Mejora la calidad de tu señal de wifi</h2>
        <p>Para mejorar tu señal de wifi:</p>
        <div className="rowLine">
          <div className="accordeonContent">
            <ul className="disc">
              <li>Acerca el enrutador y el dispositivo. De ser posible, colócalos en la misma habitación. </li>
              <li>Aleja el enrutador de otros dispositivos inalámbricos y electrodomésticos. </li>
              <li>Mantén el enrutador en un espacio abierto y en una posición elevada. Los enrutadores logran una mejor recepción cuando se encuentran sobre un escritorio o una biblioteca. </li>
            </ul>
          </div>
        </div>
        <h2>Qué hacer a continuación</h2>
        <p>Si realizaste estos pasos, pero Mega GO aún no funciona, puedes contactarte con el Servicio al Cliente de Mega GO para obtener asistencia. </p>
      </>
  }
];